import { Component, OnInit } from '@angular/core';
import { Observable, interval } from 'rxjs';
import {
  delay,
  finalize,
  map,
  shareReplay,
  takeUntil,
  tap,
} from 'rxjs/operators';
import {
  clearInterval as newClearInterval,
  setInterval as newSetInterval,
} from 'worker-timers';

import { PageNames } from 'src/app/configs/page-names.enum';
import { CustomResultOfListOfGetQueuesStatisticsDto } from 'src/app/core/api/models';
import { GetQueuesStatisticsDto } from 'src/app/core/api/models/get-queues-statistics-dto';
import { RabbitStatisticsService } from 'src/app/core/api/services';
import { DynamicTabService } from 'src/app/core/services/dynamic-tab.service';
import { RefreshMenuService } from 'src/app/core/services/refresh-menu.service';
import { TranslationService } from 'src/app/i18n';
import { TabsDynamicComponent } from 'src/app/layout/components/tabs-dynamic/tabs-dynamic.component';
import { EventTypes } from '../../../../core/constants/event-types';
import { BaseIndexPageComponent } from '../../../shared/base/components/base-index-page.component';

@Component({
    selector: 'app-get-queues-statistics',
    templateUrl: './get-queues-statistics.component.html',
    styleUrls: ['./get-queues-statistics.component.scss'],
    standalone: false
})
export class GetQueuesStatisticsComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region properties

  pageName = PageNames.queuesStatistics;
  modelWithPagination$: Observable<Array<GetQueuesStatisticsDto>>;
  items$: Observable<Array<GetQueuesStatisticsDto>>;
  items: GetQueuesStatisticsDto[] = [];

  vocabsPatch: string;
  tabName: string = 'queuesStatistics';
  //milliseconds delay after the user stops scrolling;
  throttle = 300;
  // this event is triggered when 90% (100% - 10%) has been scrolled
  infiniteScrollDistance = 1; // 1 ==> 10%

  lastUpdateDateTime: any = new Date().toISOString();

  timerValue: number = 0;
  timerIntervalId: any;

  //#endregion

  constructor(
    protected currentService: RabbitStatisticsService,
    protected dynamicTabService: DynamicTabService,
    public refreshMenuService: RefreshMenuService,
    protected tabsDynamicComponent: TabsDynamicComponent,
    public translationService: TranslationService
  ) {
    super();
  }

  ngOnInit() {
    try {
      this.getVocabs();
      this.setDefaultTableSort();
      this.configPage();
      this.pageConfig.loading = true;
      this.getTableData();
      this.pageConfig.showDefaultBtns = false;
      this.pageConfig.isShowTable = false;
      this.pageConfig.showLoadingBar = false;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  ngAfterViewInit(): void {
    this.updateData();
  }

  updateData() {
    interval(5000)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((value) => {
        this.timerValue = 1;
        this.getTableData();
        this.startTimer();
      });
  }

  startTimer() {
    if (this.timerIntervalId) newClearInterval(this.timerIntervalId);
    this.timerValue = 0;
    this.timerIntervalId = newSetInterval(() => {
      this.timerValue++;
    }, 1000);
  }

  getTableData() {
    this.pageConfig.hasError = false;
    this.unCheckSelectAll();

    //گرفتن اطلاعات از سرور
    this.modelWithPagination$ = this.getPaginationApi().pipe(
      map((res) => res.data),
      shareReplay()
      // catchError((error) => {
      //   this.pageConfig.isEmpty = false;
      //   this.pageConfig.hasError = true;
      //   return error;
      // })
    );

    this.getItems();
    this.checkSelectedItems();
  }

  getItems() {
    try {
      this.modelWithPagination$
        .pipe(
          tap((item) => {
            this.getPaginationData(item);
          }),
          tap((items) => {
            items?.length > 0
              ? (this.pageConfig.isEmpty = false)
              : (this.pageConfig.isEmpty = true);
          }),
          takeUntil(this.onDestroy$),
          delay(300),
          finalize(() => {
            this.pageConfig.loading = false;
          })
        )
        .subscribe((items) => {
          this.items = items;
          this.lastUpdateDateTime = new Date().toISOString();
        });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  configTableColumns(): void {}

  //#region api

  //get All
  getPaginationApi(): Observable<CustomResultOfListOfGetQueuesStatisticsDto> {
    return this.currentService.rabbitStatisticsGetQueuesStatistics({
      query: {},
    });
  }

  //#endregion

  onScrollDown() {
    try {
      const totalCount = this.paginationModel.totalCount;

      if (this.items.length == totalCount) return;

      const totalPages = this.paginationModel.totalPages;
      const pageNumber = this.paginationModel.pageNumber;

      if (this.pageConfig.loading) return;

      this.pageConfig.loading = true;

      if (pageNumber < totalPages) this.paginationModel.pageNumber++;

      this.getTableData();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  trackByFunc(index: number, item) {
    try {
      return item.name;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }
}
